import i18n, { t } from 'i18next';
export const ResponseStatusCode = {
  BadRequest: 400,
  Unauthorized: 401,
  Forbidden: 403,
  Success: 200,
};

export const HeadersKey = {
  Authorization: {
    response: 'set-authorization',
    request: 'Authorization',
  },
  StoreId: 'store-id',
};

export const GenericErrorMessage = t('GenericErrorMessage');
